import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {ROUTE_PATHS} from '@di-shared/routes';

interface DiagBatteryPageProps {
  vin: string;
}

function DiagBatteryPage({vin}: DiagBatteryPageProps) {
  const location = useLocation();
  if (location.pathname === ROUTE_PATHS.DIAG_BATTERY.getFullPath(vin)) {
    return (
      <Navigate
        replace
        to={ROUTE_PATHS.DIAG_BATTERY_DISCHARGE.getFullPath(vin)}
      />
    );
  }
  return <Outlet />;
}

export default DiagBatteryPage;
